module.exports = __webpack_public_path__ + "static/img/CM.65f87b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CM.jpg
// module id = hBR6
// module chunks = 0